"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = void 0;
var _vue = _interopRequireDefault(require("vue"));
var EventBus = exports.EventBus = new _vue.default();